<style scoped>

.scrolllll {
    max-height: 350px;
    overflow-y: auto;
}
</style>

<template>

<v-container grid-list-xs,sm,md,lg,xl>

    <v-layout row wrap justify-center>

      <h1 class="text-xs-center">{{content.title}}</h1>

        <v-flex v-if="form" xs12>

            <v-layout row wrap justify-space-between>

                <v-flex xs12 sm6 lg4 class="px-1 mt-2">
                    <h2 class="text-xs-center mb-2">{{content.select_switches}}</h2>

                    <div class="text-xs-left">
                      <v-btn flat small color="primary" @click="toggleAllSwitches()">{{selectedSwitches.length !== Object.keys(this.switches).length ? content.checkall : content.uncheckall }}</v-btn>
                    </div>
                    <v-card class="px-3 pt-2 scrolllll scrollbar">
                        <v-checkbox v-for="(sw, index) in switches" :key="sw.id" v-model="selectedSwitches" :label="sw.identifier +' - '+ sw.name" :value="sw.slug" class="text-xs-left mt-1 mb-1"></v-checkbox>
                    </v-card>
                </v-flex>

                <v-flex xs12 sm6 lg3 class="px-1 mt-2">
                    <h2 class="text-xs-center mb-2">{{content.select_parameters}}</h2>

                    <div class="text-xs-left">
                      <v-btn flat small color="primary" @click="toggleAllParameters()">{{selectedParameters.length !== parameters.length ? content.checkall : content.uncheckall}}</v-btn>
                    </div>
                    <v-card class="px-3 pt-2">
                        <v-checkbox v-for="(parm, index) in parameters" :key="index" v-model="selectedParameters" :label="parm" :value="parm" class="text-xs-left mt-1 mb-1"></v-checkbox>
                    </v-card>
                </v-flex>

                <v-flex xs12 sm6 lg4 class="px-1 mt-2">
                    <h2 class="text-xs-center mb-2">{{content.select_dates}}</h2>

                    <v-flex xs12 d-flex row wrap justify-space-between>
                      <v-btn flat small color="primary" @click="timeFormat('today')">{{content.today}}</v-btn>
                      <v-btn flat small color="primary" @click="timeFormat('week')">7 {{content.days}}</v-btn>
                      <v-btn flat small color="primary" @click="timeFormat('30days')">30 {{content.days}}</v-btn>
                    </v-flex>
                    <v-card class="px-3 pt-2">

                        <h4>{{content.startat}}:</h4>

                        <v-dialog ref="sdate" v-model="startAtMenu" :return-value.sync="startAtDate" persistent full-width width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="startAtDate" :label="content.date" prepend-icon="event" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker ref="edpicker" v-model="startAtDate" scrollable :max="new Date().toISOString().substr(0, 10)" min="2019-06-01" :locale="locale == 'he' ? 'he-il' : 'en-us'">
                                <v-btn text color="grey" flat @click="startAtMenu = false">{{content.cancel}}</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="$refs.sdate.save(startAtDate)">{{content.ok}}</v-btn>
                            </v-date-picker>
                        </v-dialog>
                        <v-dialog ref="startTime" v-model="startTimeDialog" :return-value.sync="startAtTime" persistent full-width max-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="startAtTime" :label="content.time" prepend-icon="access_time" readonly v-on="on"></v-text-field>
                            </template>
                            <v-time-picker v-if="startTimeDialog" v-model="startAtTime" full-width format="24hr">
                                <v-btn text color="grey" flat @click="startTimeDialog = false">{{content.cancel}}</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="$refs.startTime.save(startAtTime)">{{content.ok}}</v-btn>
                            </v-time-picker>
                        </v-dialog>

                        <v-divider></v-divider>

                        <h4 class="mt-2">{{content.endat}}:</h4>

                        <v-dialog ref="edate" v-model="endAtMenu" :return-value.sync="endAtDate" persistent full-width width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="endAtDate" :label="content.date" prepend-icon="event" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker ref="endDatePicker" v-model="endAtDate" scrollable :max="new Date().toISOString().substr(0, 10)" :min="endTimeMinimum" :locale="locale == 'he' ? 'he-il' : 'en-us'">
                                <v-btn text flat color="grey" @click="endAtMenu = false">{{content.cancel}}</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="$refs.edate.save(endAtDate)">{{content.ok}}</v-btn>
                            </v-date-picker>
                        </v-dialog>

                        <v-dialog ref="endTime" v-model="endTimeDialog" :return-value.sync="endAtTime" persistent full-width max-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="endAtTime" :label="content.time" prepend-icon="access_time" readonly v-on="on"></v-text-field>
                            </template>
                            <v-time-picker v-if="endTimeDialog" v-model="endAtTime" full-width format="24hr">
                                <v-btn text color="grey" flat @click="endTimeDialog = false">{{content.cancel}}</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="$refs.endTime.save(endAtTime)">{{content.ok}}</v-btn>
                            </v-time-picker>
                        </v-dialog>

                    </v-card>
                </v-flex>

            </v-layout>

            <v-layout row wrap justify-center class="mt-4">
                <v-flex xs12 sm10 md8 lg6>
                    <v-alert :value="error ? true : false" transition="scale-transition" dense outline type="error"><span class="px-3">{{error}}</span></v-alert>
                    <v-btn color="primary" @click="create()" block>{{content.create_file}}</v-btn>
                </v-flex>
            </v-layout>

        </v-flex>

        <v-flex v-else xs12>

          <v-layout row wrap justify-center>

            <v-flex xs10 sm8 md6 class="mt-4">
              <h3 class="text-xs-center">{{generateStatus}}</h3>
              <template>
                <v-progress-linear value="100" :color="generateColor" :indeterminate="generateProgress"></v-progress-linear>
              </template>
            </v-flex>

            <v-flex v-if="fileUrl" xs12 class="text-xs-center" justify-center>
              <v-btn color="success" :href="fileUrl" :download="fileDownloadName">{{content.download}}</v-btn>
            </v-flex>

            <v-flex v-if="fileUrl" xs12 class="mt-5 text-xs-center" justify-center>
              <v-btn color="light-blue" dark class="mt-2 text-xs-center" @click="createNew()">{{content.create_another_file}}</v-btn>
            </v-flex>
          </v-layout>

        </v-flex>

    </v-layout>

</v-container>

</template>

<script>

import { mapGetters } from 'vuex'
export default {
    props: ['locale', 'dir'],
    data() {
            return {
                form: true,
                // switches: this.devices,
                selectedSwitches: [],
                selectedParameters: [],
                startAtMenu: false,
                startAtDate: null,
                endAtMenu: false,
                endAtDate: null,
                startAtTime: '00:00',
                startTimeDialog: false,
                endAtTime: '23:59',
                endTimeMinimum: '2019-06-01',
                endTimeDialog: false,
                error: null,
                generateStatus: 'GENERATING FILE',
                generateProgress: true,
                generateColor: 'primary',
                fileName: null,
                fileDownloadName: null,
                fileUrl: null,
            };
        },
        created() {
            this.setLang();
            this.toggleAllSwitches();
        },
        computed: mapGetters({
          switches: 'devices/devices',
        }),
        watch: {
            startAtMenu(val) {
                val && setTimeout(() => (this.$refs.edpicker.activePicker = 'YEAR'))
            },
            endAtMenu(val) {
              val && setTimeout(() => (this.$refs.endDatePicker.activePicker = 'YEAR'))
            },
            startAtDate: function (val) {
              this.endTimeMinimum = val;
              if (val > this.endAtDate) {
                this.endAtDate = null;
              }
            },
        },
        methods: {
            getSwitches() {
                  // this.switches = Devices.get();
                    // axios.get(
                    //     'api/switch/list'
                    // ).then(res => {
                    //     this.switches = res.data;
                    //     Load.off();
                    //     this.loading = false;
                    // }).catch(err => {
                    //     console.log(err);
                    // });
                },
                create() {
                    if (this.selectedSwitches.length < 1) {
                        this.error = this.errorText[0];
                    } else {
                        if (this.selectedParameters.length < 1) {
                            this.error = this.errorText[1];
                        } else {
                          if (!this.startAtDate || (this.startAtDate && this.startAtDate.length < 1)) {
                            this.error = this.errorText[2];
                          } else {
                            if (!this.startAtTime || (this.startAtTime && this.startAtTime.length < 1)) {
                              this.error = this.errorText[3];
                            } else {
                              if (!this.endAtDate || (this.endAtDate && this.endAtDate.length < 1)) {
                                this.error = this.errorText[4];
                              } else {
                                if (!this.endAtTime || (this.endAtTime && this.endAtTime.length < 1)) {
                                  this.error = this.errorText[5];
                                } else {
                                  this.error = null;
                                  this.send();
                                }
                              }
                            }
                          }
                        }
                    }
                },
                send(){
                  this.generateStatus = this.content.generation[0];
                  this.form = false;
                  axios.post(
                    'api/logs/create-file-request',
                    {
                      selectedSwitches: this.selectedSwitches,
                      selectedParameters: this.selectedParameters,
                      startAtDate: this.startAtDate,
                      endAtDate: this.endAtDate,
                      startAtTime: this.startAtTime,
                      endAtTime: this.endAtTime,
                    }
                  ).then(res => {
                    this.form = false;
                    this.generateFile();
                  }).catch(err => {
                    console.log(err);
                  });
                },
                toggleAllSwitches() {
                    if (this.selectedSwitches.length === Object.keys(this.switches).length) {
                        this.selectedSwitches = [];
                    } else {
                        this.selectedSwitches = [];
                        for (let s in this.switches) {
                            this.selectedSwitches.push(this.switches[s].slug);
                        }
                    }
                },
                toggleAllParameters() {
                    if (this.selectedParameters.length === this.parameters.length) {
                        this.selectedParameters = [];
                    } else {
                        this.selectedParameters = [];
                        for (let s in this.parameters) {
                            this.selectedParameters.push(this.parameters[s]);
                        }
                    }
                },
                timeFormat(time) {
                  switch (time) {
                    case 'today':
                      this.startAtDate = new Date().toISOString().substr(0, 10);
                      this.endAtDate = new Date().toISOString().substr(0, 10);
                      this.startAtTime = '00:00';
                      this.endAtTime = '23:59';
                      break;
                    case 'week':
                      this.startAtDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10);
                      this.endAtDate = new Date().toISOString().substr(0, 10);
                      this.startAtTime = '00:00';
                      this.endAtTime = '23:59';
                      break;
                    case '30days':
                      this.startAtDate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10);
                      this.endAtDate = new Date().toISOString().substr(0, 10);
                      this.startAtTime = '00:00';
                      this.endAtTime = '23:59';
                      break;
                  }
                },
                generateFile() {
                  axios.get(
                    'api/logs/generate-file'
                  ).then(res => {
                    this.fileName = res.data;
                    this.getFile();
                  }).catch(err => {
                    console.log(err);
                  });
                },
                getFile() {
                  this.generateStatus = this.content.generation[1];
                  axios({
                    method: 'post',
                    url: 'api/logs/download-file',
                    responseType: 'blob',
                    data: {name: this.fileName}
                  }).then(res => {
                    this.fileDownloadName = this.fileName;
                    let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    blob.name = this.fileName;
                    let url;
                    if ( window.webkitURL ) {
                      url = window.webkitURL.createObjectURL(blob);
                    } else if ( window.URL && window.URL.createObjectURL ) {
                      url = window.URL.createObjectURL(blob);
                    } else {
                      url = false;
                    }
                    // this.fileDownloadName = Auth.name() +'-'+ Date.now();
                    this.fileDownloadName = this.fileName;
                    this.generateProgress = false;
                    this.generateColor = 'success';
                    this.fileUrl = url;
                    this.generateStatus = this.content.generation[2];
                  }).catch(err => {
                    console.log(err);
                  });
                },
                createNew() {
                  this.selectedSwitches = [];
                  this.selectedParameters = this.parameters;
                  this.startAtDate = null;
                  this.endAtDate = null;
                  this.startAtTime = '00:00';
                  this.endAtTime = '23:59';
                  this.endTimeMinimum = '2019-06-01';
                  this.form = true;
                  this.generateProgress = true;
                  this.generateColor = 'primary';
                  this.fileName = null;
                  this.fileDownloadName = null;
                  this.fileUrl = null;
                },
                setLang() {
                    if (this.locale == "en") {
                        this.parameters = ['status', 'temperature', 'humidity', 'light'];
                        this.selectedParameters = ['status', 'temperature', 'humidity', 'light'];
                        this.content = {
                          title: "Download Logs File",
                          select_switches: "Select Switches",
                          select_parameters: "Select Parameters",
                          select_dates: "Select Dates",

                          today: 'Today',
                          days: 'Days',
                          startat: 'Start At',
                          endat: 'End At',
                          date: 'Date',
                          time: 'Time',

                          ok: 'OK',
                          cancel: 'Cancel',

                          checkall: "Check All",
                          uncheckall: "Uncheck All",

                          create_file: 'Create File',
                          generation: ['GENERATING FILE','PREPARING FOR DOWNLOAD','READY TO DOWNLOAD!'],
                          download: 'Download',
                          create_another_file: 'Create Another File',
                        };
                        this.errorText = [
                          'Must select atleast one switch',
                          'Must select atleast one parameter',
                          'Must select a start date',
                          'Must select a start time',
                          'Must select an end date',
                          'Must select an end time',
                        ];
                    } else if (this.locale == "he") {
                        this.parameters = ['סטטוס', 'טמפרטורה', 'לחות', 'אור'];
                        this.selectedParameters = ['סטטוס', 'טמפרטורה', 'לחות', 'אור'];
                        this.content = {
                          title: "הורדת קובץ לוגים",
                          select_switches: "בחירת מכשירים",
                          select_parameters: "בחירת פרמטרים",
                          select_dates: "בחירת זמנים",

                          today: 'היום',
                          days: 'ימים',
                          startat: 'מתחיל ב',
                          endat: 'נגמר ב',
                          date: 'תאריך',
                          time: 'שעה',

                          ok: 'אישור',
                          cancel: 'ביטול',

                          checkall: "סמן הכל",
                          uncheckall: "בטל סימון של הכל",

                          create_file: 'יצירת קובץ',
                          generation: ['מייצר קובץ','מכין להורדה','מוכן להורדה!'],
                          download: 'הורדה',
                          create_another_file: 'צור קובץ אחר',
                        };
                        this.errorText = [
                          'חובה לבחור לפחות מכשיר אחד',
                          'חובה לבחור לפחות פרמטר אחד',
                          'חובה לבחור תאריך התחלה',
                          'חובה לבחור שעת התחלה',
                          'חובה לבחור תאריך סיום',
                          'חובה לבחור שעת סיום',
                        ];
                    }
                }
        }
};

</script>
